import { Button, Layout, Typography, Card, Alert } from "antd";
import { useAuth0 } from "@auth0/auth0-react";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

export const Login: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const [searchParams] = useSearchParams();
  const [facilityInvite, setFacilityInvite] = useState<string | null>(null);
  const [inviteEmail, setInviteEmail] = useState<string | null>(null);

  useEffect(() => {
    // Check if this is a facility invitation login from URL parameters
    const facilityId = searchParams.get("facility_invite");
    const email = searchParams.get("email");
    const success = searchParams.get("success"); // From Auth0 password reset redirect
    
    if (facilityId) {
      setFacilityInvite(facilityId);
      setInviteEmail(email);
    }

    // If user just completed password reset, show success message
    if (success === "true") {
      console.log("Password reset completed successfully");
    }
  }, [searchParams]);

  const handleLogin = () => {
    const loginOptions: any = {
      authorizationParams: {
        prompt: "select_account"
      }
    };

    // Pre-fill email if from invitation
    if (inviteEmail) {
      loginOptions.authorizationParams.login_hint = inviteEmail;
    }

    // Add facility context to redirect URI state
    if (facilityInvite) {
      loginOptions.appState = {
        returnTo: `/auth/callback?type=facility_invite&facility=${facilityInvite}`
      };
    }

    loginWithRedirect(loginOptions);
  };

  return (
    <Layout
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f4f6f8",
      }}
    >
      <Card
        variant="outlined"
        style={{
          width: 380,
          padding: "32px",
          textAlign: "center",
          background: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Branding */}
        <Typography.Title level={3} style={{ marginBottom: "24px", color: "#333" }}>
          CodePilot
        </Typography.Title>

        {/* Facility Invitation Alert */}
        {facilityInvite && (
          <Alert
            message="Facility Invitation"
            description={
              searchParams.get("success") === "true" 
                ? "Great! Your password has been set. Now please sign in below to complete joining the facility."
                : "Welcome! You've successfully set your password. Please sign in to complete joining the facility."
            }
            type="success"
            showIcon
            style={{ marginBottom: "24px", textAlign: "left" }}
          />
        )}

        {/* Sign-in Button */}
        <Button
          type="primary"
          size="large"
          style={{
            width: "100%",
            fontSize: "16px",
            fontWeight: "bold",
            borderRadius: "8px",
            background: "#1677ff",
            borderColor: "#1677ff",
            transition: "0.3s",
          }}
          onClick={handleLogin}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#125cc3")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#1677ff")}
        >
          {facilityInvite ? "Sign in to Join Facility" : "Sign in to CodePilot"}
        </Button>

        {/* Footer */}
        <Typography.Text type="secondary" style={{ display: "block", marginTop: "16px", color: "#888" }}>
          Smarter Medical Coding with AI-Driven Precision.
        </Typography.Text>
      </Card>
    </Layout>
  );
};
